import Vue from 'vue'
import Vuex from 'vuex'

import Auth from '@/plugins/auth'
import Feature from '@/plugins/feature'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    Auth.plugin,
    Feature.plugin
  ],
  state,
  getters,
  mutations,
  actions
})

export default store
